export const OAuthKey = {
    Facebook: 'facebook',
    Twitter: 'twitter',
    Line: 'line',
    Google: 'google',
    Apple: 'apple',
    More: 'more',
};

// 目前支持的三方登录
export const OAuths = {
    facebook: {
        label: 'Facebook',
        value: '10',
        url: 'https://www.facebook.com/v17.0/dialog/oauth',
        icon: require('@/assets/img/icon_meta.png'),
    },
    twitter: {
        label: 'Twitter',
        value: '100000',
        url: 'https://api.twitter.com/oauth/authenticate',
        icon: require('@/assets/img/icon_twitter.png'),
    },
    line: {
        label: 'Line',
        value: '1000000',
        url: 'https://access.line.me/dialog/oauth/weblogin',
        icon: require('@/assets/img/icon_line.png'),
    },
    google: {
        label: 'Google',
        value: '100',
        url: 'https://accounts.google.com/o/oauth2/v2/auth',
        icon: require('@/assets/img/icon_google.png'),
    },
    apple: {
        label: 'Apple',
        value: '1000',
        url: 'https://appleid.apple.com/auth/authorize',
        icon: require('@/assets/img/icon_apple.png'),
    },
};

export const OAuthError = {
    // Twitter 重复登录
    TwitterRepeatLogin: {
        code: -1,
        data: null,
        msg: 'This feature is temporarily unavailable',
    },
};
